
import { API_BASE_URL } from "../../config/api";
import UserServices from "../../services/UserServices";


async function posthttps(url,body) {
  let response = await fetch(`${API_BASE_URL}/${url}`, {
    method: "POST",
    body: JSON.stringify(body),
    headers: UserServices.createHeaders()
  });
  let data = await response.json();

  return data;
 
}

export default posthttps;
